export const ITEM_CARD_IMAGE_MODES = {
    SQUARE: 'SQUARE',
    NATURAL: 'NATURAL'
};
